

export class TyreModelStatusInput implements ITyreModelStatusInput {
    /** The auto-generated id of the tyre model master */
    tyreModelId!: number;
    /** The updated status */
    status!: number;

    constructor(data?: ITyreModelStatusInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tyreModelId = _data["tyreModelId"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): TyreModelStatusInput {
        data = typeof data === 'object' ? data : {};
        let result = new TyreModelStatusInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tyreModelId"] = this.tyreModelId;
        data["status"] = this.status;
        return data; 
    }
}

export interface ITyreModelStatusInput {
    /** The auto-generated id of the tyre model master */
    tyreModelId: number;
    /** The updated status */
    status: number;
}

